<template>
  <v-container
    class="pa-0"
    fill-height
    fluid
    v-if="!$apollo.queries.me.loading"
  >
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <v-list two-line>
          <v-list-tile v-for="account in vscAccounts">
            <v-list-tile-avatar>
              <v-icon
                class="info white--text"
                v-if="account === 'personal'"
              >account_balance_wallet</v-icon>
              <v-icon
                class="success white--text"
                v-else
              >account_balance</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ account }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ me.vscBalance[account] | separator }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action v-if="account === 'personal'">
              <v-btn
                :loading="$wait.is('credits purchase')"
                @click="buyCredits"
                icon
                disabled
              >
                <v-icon color="info">shopping_cart</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import meMixin from '@/mixins/me';
import { ME, BUY_CREDITS } from '@/graphql.gql';

export default {
  mixins: [meMixin],
  methods: {
    async buyCredits() {
      try {
        this.$wait.start('credits purchase');
        await this.$apollo.mutate({
          mutation: BUY_CREDITS,
          variables: { amount: 100 },
          update: (store, { data: { buyCredits } }) => {
            const data = store.readQuery({ query: ME });
            data.me.vscBalance = buyCredits.vscBalance;
            store.writeQuery({ query: ME, data });
          },
          optimisticResponse: {
            __typename: 'Mutation',
            buyCredits: {
              __typename: 'BuyCredits',
              vscBalance: this.me.vscBalance,
            },
          },
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        this.$snackbar.show('We could not purchase more credits now. Please, try again.');
      } finally {
        this.$wait.end('credits purchase');
      }
    },
  },
  created() {
    this.$store.dispatch('setTitle', 'Credits');
  },
};
</script>
